/* eslint-disable quotes */
import {Fragment, useEffect, useState} from 'react';

type TProps = {title?: string; body?: string; children: React.ReactNode};

const CardCollapse = (props: TProps) => {
	const [title, setTitle] = useState('');
	const [, setBody] = useState('');

	useEffect(() => {
		setTitle(props.title ? props.title : 'Basic Card Example');
		setBody(
			props.body
				? props.body
				: "This is a collapsable card example using Bootstrap's built in collapse functionality. <strong>Click on the card header</strong> to see the card body collapse and expand!",
		);
	}, [props.body, props.title]);

	return (
		<Fragment>
			<div className="card shadow mb-4">
				{/* <!-- Card Header - Accordion --> */}
				<a
					href="#collapseCardExample"
					className="d-block card-header py-3"
					data-toggle="collapse"
					role="button"
					aria-expanded="true"
					aria-controls="collapseCardExample">
					<h6 className="m-0 font-weight-bold text-primary">{title}</h6>
				</a>
				{/* <!-- Card Content - Collapse --> */}
				<div className="collapse show" id="collapseCardExample">
					<div className="card-body">{props.children}</div>
				</div>
			</div>
		</Fragment>
	);
};

export default CardCollapse;
